import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";

import Supplies from "../pages/Catalogs/Supplies/Existence";
import SuppliesValidation from "../pages/Catalogs/Supplies/Validation";

const RoadConcepts = () => import("../pages/Catalogs/RoadConcepts");
import RoadConceptsAdvance from "@/pages/Catalogs/RoadConceptsAdvance";

const suppliesPages = {
  path: "/",
  component: DashboardLayout,
  name: " Insumos",
  title: "Insumos",
  // roles: ['PROV', 'ARE', 'GECA', 'AUXADMIN', 'AUDITOR', 'COMPRAS'],
  // ifCan: {
  // View: [ 'Family', 'SuFamily' ]
  // },
  icon: "widgets",
  excludedGroups: ["Extranet"],
  excludedRoles: ["IDEAL"],
  children: [
    {
      path: "/families",
      name: "Familia de Insumos",
      title: "Familia de Insumos",
      component: Supplies,
      meta: {
        ifUserCan: {
          view: "Services/family",
        },
      },
    },
    {
      path: "/validacion-insumos",
      name: "Validacion de Insumos",
      title: "Validación de Insumos",
      component: SuppliesValidation,
      meta: {
        ifUserCan: {
          ["supply_validation"]: "Services/supply",
        },
      },
    },
    {
      path: "/conceptos_carreteros",
      name: "Conceptos carreteros",
      title: "Conceptos Carreteros",
      component: RoadConcepts,
      meta: {
        ifUserCan: {
          view: "Services/roadconceptjb",
        },
      },
    },
    {
      path: "/conceptos_carreteros_avanzado",
      name: "Conceptos carreteros Avanzado",
      title: "Conceptos Carreteros Avanzado",
      component: RoadConceptsAdvance,
      meta: {
        ifUserCan: {
          view: "Services/roadconceptjb",
        },
      },
    },
  ],
};

export default suppliesPages;



// WEBPACK FOOTER //
// ./src/router/suppliesRoutes.js